import _ from 'lodash';

/**
 * Je validne zip?
 *
 * @param {string} zip
 *
 * @return {boolean}
 */
export const isValidZip = zip => /^[0-9a-zA-Z ]{4,10}$/.test(_.toString(zip));
